import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import {
  fetchCustomerPortalLink,
  fetchSubscriptionPacks,
  getStripeRecurring,
  type GetStripeRecurringProps,
  getSubscriptionDetails,
  type IGetSubscriptionDetailsProps,
} from '../../api/subscription'

type SubscriptionDetails = Awaited<ReturnType<typeof getSubscriptionDetails>>

export const useSubscriptionDetails = (
  props: IGetSubscriptionDetailsProps,
  isAuthenticated: boolean,
  subscriptionName?: string,
): UseQueryResult<SubscriptionDetails, AxiosError> =>
  useQuery({
    queryKey: ['getSubscriptionDetails', props],
    queryFn: () => getSubscriptionDetails(props),
    enabled: isAuthenticated && !!props.organization_id,
    refetchInterval: ({ state: { data: subscriptionData } }) => {
      return subscriptionName &&
        subscriptionData?.billingDetails.planName !== subscriptionName
        ? 20000
        : false
    },
  })

export const useStripeRecurring = () =>
  useQuery({
    queryKey: ['getStripeRecurring'],
    queryFn: () => getStripeRecurring(),
    networkMode: 'always',
  })

type CustomerPortalLink = Awaited<ReturnType<typeof fetchCustomerPortalLink>>
export const useCustomerPortalLink = ({
  token,
}: GetStripeRecurringProps): UseQueryResult<CustomerPortalLink, AxiosError> =>
  useQuery({
    queryKey: ['getCustomerPortalLink', token],
    queryFn: () => fetchCustomerPortalLink(),
    enabled: false,
  })

export const useSubscriptionProductPacks = () =>
  useQuery({
    queryKey: ['getSubscriptionProductPacks'],
    queryFn: () => fetchSubscriptionPacks(),
    networkMode: 'always',
  })
